import { ModalSize } from "./Modal.types";

export const MODAL_SIZE_CLASSNAMES = {
    [ModalSize.Small]: "sm:max-w-lg",
    [ModalSize.Medium]: "md:max-w-2xl",
    [ModalSize.Large]: "lg:max-w-3xl",
    [ModalSize.ExtraLarge]: "lg:max-w-6xl",
};

export const MODAL_HOLDER_SIZE_CLASSNAMES = {
    [ModalSize.Small]: "sm:p-0",
    [ModalSize.Medium]: "md:p-0",
    [ModalSize.Large]: "lg:p-0",
    [ModalSize.ExtraLarge]: "xl:p-0",
};
